// LiveTotalCard.js — the one navy money surface, anchoring the right rail.
// A headline figure (mono 30–36) plus secondary rows that update live as the
// rep edits. Fed by buildTotals (audit F-04). Positive deltas may use
// v3.color.moneyPositive (on the navy card only). Faithful port of
// components/workspace/LiveTotalCard.jsx.
import React from 'react';
import { v3 } from '../../lib/styleTokens';

export function LiveTotalCard({ label = 'Live total', headline, headlineSub = '/mo', rows = [] }) {
  return (
    <div
      style={{
        padding: 20,
        background: v3.color.navy,
        color: '#FFFFFF',
        borderRadius: v3.radius.cardLarge,
        fontFamily: v3.font.family,
      }}
    >
      <div
        style={{
          fontSize: v3.font.size.micro,
          color: 'rgba(255,255,255,0.55)',
          fontWeight: v3.font.weight.semibold,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontFamily: v3.font.mono,
          fontSize: v3.font.size.money,
          fontWeight: v3.font.weight.semibold,
          marginTop: 6,
          letterSpacing: v3.font.letterSpacing.tighter,
        }}
      >
        {headline}
        {headlineSub && (
          <span style={{ fontSize: v3.font.size.body, color: 'rgba(255,255,255,0.55)', marginLeft: 4 }}>
            {headlineSub}
          </span>
        )}
      </div>
      {rows.length > 0 && (
        <div
          style={{
            marginTop: 14,
            paddingTop: 14,
            borderTop: '1px solid rgba(255,255,255,0.12)',
            display: 'grid',
            gap: 10,
            fontSize: v3.font.size.small,
          }}
        >
          {rows.map((r, i) => (
            <div key={i} style={{ display: 'flex' }}>
              <span style={{ flex: 1, color: 'rgba(255,255,255,0.65)' }}>{r.label}</span>
              <span style={{ fontFamily: v3.font.mono, color: r.color || 'rgba(255,255,255,0.85)', fontWeight: v3.font.weight.semibold }}>
                {r.value}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
